<template>
  <el-dialog
    title="选择物料"
    :visible.sync="dialogVisible"
    width="1000px">
    <div class="check-work-body d-flex">
      <div class="d-flex-left">
        <div class="tree-wrap">
          <div class="el-tree-1">
            <el-tree ref="tree" highlight-current :data="treeData" empty-text="没有数据" :props="defaultProps"
                     @node-click="handleNodeClick"></el-tree>
          </div>
        </div>
      </div>
      <div class="d-flex-right" style="width:900px">
        <div class="hr-setting-post-view" style="height: 600px;">
          <el-row :gutter="20">
            <el-col :span="6">
              <div >
                <el-input v-model="where.product_name" placeholder="商品名称"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div >
                <el-input v-model="where.sku_code" placeholder="商品编码"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div >
                <el-button @click="searchs">搜索</el-button>
              </div>
            </el-col>
          </el-row>
          <div class="mt-10">
            <el-table :data="pageData.list" border style="width: 100%;font-size: 12px;" v-loading="loading">
              <el-table-column prop="sku_code" label="商品编码"></el-table-column>
              <el-table-column prop="product_name" label="物资名称"></el-table-column>
              <el-table-column prop="cate_name" label="物资分类"></el-table-column>
              <el-table-column prop="sku_attr" label="规格型号"></el-table-column>
              <el-table-column prop="unit" label="计量单位"></el-table-column>
              <el-table-column prop="price" label="参考进价"></el-table-column>
              <el-table-column prop="" label="操作">
                <template slot-scope="scope">
                  <el-button type="primary" @click="confirmFun(scope.row)">选择</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-pagination background layout="total, prev, pager, next, jumper, sizes"
                       :total="pageData.total"
                       v-model:current-page="pageData.page"
                       v-model:page-size="pageData.pageSize"
                       class="pagination" @current-change="pageChange"/>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import Http from "../common/YsHttp";

export default {
  name: "SelectMaterial",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      where: {},
      pageData: {},
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'cate_name'
      },
      callback_fun: undefined,
    }
  },
  mounted() {
    this.initConfig()
    // this.getUserRoleList()
  },
  methods: {
    initConfig() {
      this.where = {
        product_name: '',
        sku_code: '',
        status: 5,
        category_id: 0
      }
      this.pageData = {
        list: [],
        page: 1,
        total: 0,
        pageSize: 7
      };
      this.callback_fun = undefined;
      this.selectData = [];
    },
    /**
     * 显示流程
     */
    show({}, callback_fun) {
      const that = this;
      that.initConfig();

      that.dialogVisible = true;
      if (typeof callback_fun === "function") {
        that.callback_fun = callback_fun;
      }
      that.getList();
      that.getTreeData();
    },
    confirmFun(data) {
      if (typeof this.callback_fun === "function") {
        this.callback_fun(data);
        this.callback_fun = undefined;
      }
      this.dialogVisible = false;
    },
    closeFun() {
      if (typeof this.callback_fun === "function") {
        this.callback_fun = undefined;
      }
      this.dialogVisible = false;
    },
    getList() {
      const that = this;
      that.loading = true;
      let getParams = Object.assign({page: that.pageData.page, pageSize: that.pageData.pageSize}, that.where)
      Http.get("procure/Product/list", getParams, res => {
        if (res.code) {
          that.pageData.list = res.data.data
          that.pageData.page = res.data.current_page
          that.pageData.pageSize = res.data.per_page
          that.pageData.total = res.data.total
        } else {
          that.pageData = [];
        }
        that.loading = false;
      })
    },
    searchs() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i;
      this.getList();
    },
    // 获取分类树状
    getTreeData() {
      let that = this
      Http.get('procure/ProductCategory/treeList', {}, res => {
        if (res.code == 200) {
          that.treeData = res.data
        }
      })
    },
    // 分类树点击
    handleNodeClick(data) {
      this.where.category_id = data.id
      this.pageData.page = 1;
      this.searchs()
    }
  }
}
</script>

<!--<style lang="scss" scoped>-->
<!--@import "../common";-->

<!--.personnel-footer {-->
<!--  margin-top: 10px;-->
<!--  width: 100%;-->
<!--  text-align: right;-->
<!--}-->
<!--</style>-->

<style lang="scss" scoped>
.search-item .label {
  width: 80px !important;
}

.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
  color: #fff;
}

.el-tree-node__label {
  font-size: 12px;
}

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
}

.amap-box {
  width: 500px;
  height: 500px;
}

.el-tree-1 {
  overflow-y: scroll;
  height: 600px;
  width: 100%;
}


.fangtai-name {
  font-size: 12px;
}

.tree-wrap {
  width: 250px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectMaterial.vue